// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__Rn1U1","wrapper-nopadding":"wrapper-nopadding__2GrF-","loading":"loading__3JEio","error":"error__1OwDu","table-loading":"table-loading__TIShx","empty-val":"empty-val__TnokK","panelheader-tools":"panelheader-tools__2isku","propsPanels":"propsPanels__1UAn_","new":"new__3T9SI","marginLm":"marginLm__1-HlN","marginRm":"marginRm__2bh3t","fullWidth":"fullWidth__2QbiG","fullHeight":"fullHeight__1NO2i","noData":"noData__2qpzA","detail-table-wrapper":"detail-table-wrapper__3L0cM","detail-table":"detail-table__15e72","bill-info":"bill-info__kC3oY","val":"val__2cBRF","sub":"sub__2UEZo"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Billing/BillDetail/styles/main.scss
// module id = 2251
// module chunks = 1